export const environment = {
  production: false,
  debug: true,
  url_api: 'https://api-dev.sduniformesybordados.com/api',
};
